import { createSlice } from '@reduxjs/toolkit';
import { loadingCancellationReducer } from './reducers/loading-cancellation.reducer';
import { updateCancellationReducer } from './reducers/update-cancellation.reducer';
import { cancellationErrorReducer } from './reducers/cancellation-error.reducer';
import { createCustomerCancellationReducer } from './reducers/create-cancellation.reducer';
import { initialCancellationState } from './state';

export const cancellationSlice = createSlice({
  name: 'Cancellation',
  initialState: initialCancellationState,
  reducers: {
    loading: loadingCancellationReducer,
    update: updateCancellationReducer,
    error: cancellationErrorReducer,
    create: createCustomerCancellationReducer,
  },
});

export const cancellationReducer = cancellationSlice.reducer;
